export default __webpack_public_path__ + "static/media/academicpoint.954432d3.svg";